import React from "react";
import DashboardLayout from "../dashboard/layout/DashboardLayout";
import SimulatorsList from "../simulators/SimulatorsList";

export default function SimulatorsPage() {
  return (
    <DashboardLayout
      activeItem="Simulators"
      title="Simulators"
      description="Create and manage simulation sessions with personas and AI agents"
    >
      <div className="h-full">
        <SimulatorsList className="h-full" />
      </div>
    </DashboardLayout>
  );
}